import { liftPlanService } from '@/services/lift-plan/lift-plan-service';
import { projectKeys } from '@/utils/queryKeys';
import { useQuery } from '@tanstack/vue-query';

export const useLiftPlanQuery = (projectId: string) => {
  return useQuery({
    queryKey: projectKeys.liftPlan({ projectId }),
    queryFn: () => liftPlanService.get(projectId),
  });
};
